/* eslint-disable react-hooks/exhaustive-deps */
import {KTCard} from '../../../_metronic/helpers'
import {Pagination} from '../../../utils/pagination'
import {InquiresPageListingContext} from '../context'
import InquiresPageTable from '../sections/table/InquiresPageTable'
import useGetInquiresData from '../hooks/useGetInquiresData'
import {useState} from 'react'
import {useGetRepresantetives} from '../hooks/useGetRepresantetives'
import useGetColumnsList from '../hooks/useGetColumnsList'
import useColumnsOperations from '../hooks/useColumnsOperations'
import InquiresPageListingHeader from '../sections/headers/InquiresPageListingHeader'
import useGetPurchasersDropdown from '../hooks/useGetPurchasersDropdown'

const InquiresAll = () => {
  const {
    globalDefaultColumnsList,
    isLoadingGlobalDefaultColumnsList,
    refetchGlobalDefaultColumnsList,
  } = useGetColumnsList()
  const {updateGlobalDefaultColumnsTableSorting, isLoadingGlobalDefaultColumnOperation} =
    useColumnsOperations()
  const {purchasers, isPurchasersLoading} = useGetPurchasersDropdown()
  const {
    InquiresData,
    filters,
    isLoading,
    onSortingChange,
    onSearch,
    onPageChange,
    pagination,
    columns,
    refetch,
    onChangeCustomerFilter,
    onChangeStatusFilter,
    onChangePurchaserFilter,
    onResetFilters,
    hasFilterApplied,
  } = useGetInquiresData()
  const [openModal, setOpenModal] = useState(false)
  const [clickedId, setClickedId] = useState('')
  const {Representatives} = useGetRepresantetives()

  const contextValue = {
    InquiresData,
    filters,
    isLoading,
    onSortingChange,
    onPageChange,
    onSearch,
    columns,
    refetch,
    openModal,
    setOpenModal,
    clickedId,
    setClickedId,
    Representatives,
    onChangeCustomerFilter,
    onChangeStatusFilter,
    onChangePurchaserFilter,
    onResetFilters,
    hasFilterApplied,

    purchasers,
    isPurchasersLoading,

    globalDefaultColumnsList,
    isLoadingGlobalDefaultColumnsList,
    refetchGlobalDefaultColumnsList,
    updateGlobalDefaultColumnsTableSorting,
    isLoadingGlobalDefaultColumnOperation,
  }

  return (
    <InquiresPageListingContext.Provider value={contextValue}>
      <KTCard>
        <InquiresPageListingHeader />
        <InquiresPageTable />
        <Pagination pagination={pagination} onPageChange={onPageChange} />
      </KTCard>
    </InquiresPageListingContext.Provider>
  )
}

export default InquiresAll
